export default {
  props: {
    colorDisabled: {
      type: String,
      default: '#263b1e',
    },
    color: {
      type: String,
      default: '#000000',
    },
    name: {
      type: String,
      required: true,
    },
    modelValue: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue'],
  data() {
    return {
      show: true,
    };
  },
  computed: {
    classModifiers() {
      return {
        'charts-checkbox': true,
        'charts-checkbox--checked': this.modelValue,
      };
    },
    tickClassModifiers() {
      return {
        'charts-checkbox__tick': true,
        'charts-checkbox__tick--checked': this.modelValue,
      };
    },
    styleModifiers() {
      return {
        'background-color': this.color,
      };
    },
  },
  methods: {
    onChange(e) {
      this.show = false;
      this.$emit('change', e.target.checked);
      this.$emit('update:modelValue', e.target.checked);
      setTimeout(() => {
        this.show = true;
      }, 0);
    },
  },
};
